import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api.trade.avegis.com', // ✅ API base URL
    headers: {
        'Content-Type': 'application/json'
    }
});

// Attach token for authenticated requests
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;
